// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\PublicTokenResponse

export type PublicTokenApiResponse = {
	token: string;
};

export type PublicToken = {
	token: string;
};

export function hydratePublicToken(data: PublicTokenApiResponse): PublicToken {
	return { ...data };
}